var module = angular.module('octopusApp.tasks', []);

module.config(function($stateProvider) {
    $stateProvider.state("app.tasks", {
        url: '/tasks',
        templateUrl: 'areas/tasks/views/index.html',
        controller: 'TasksIndexController',
        layout: {
            title: 'Tasks',
            tab: 'tasks'
        }
    });

    $stateProvider.state("app.tasks.details", {
        url: '/:taskId',
        views: {
            "@app": {
                templateUrl: 'areas/tasks/views/task.html',
                controller: 'TaskController'
            }
        },
        params: {task: null}
    });


    $stateProvider.state("app.tasks.raw", {
        url: '/:taskId/raw',
        views: {
            "@app": {
                templateUrl: 'areas/tasks/views/task-raw.html',
                controller: 'TaskRawController'
            }
        },
        params: {task: null}
    });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/tasks_module.js
// module id = 4271478855704735
// module chunks = 1